import { combineReducers } from 'redux';
import { CheckoutOrderFragment, OrderPrice } from '@websky/graphql';
import { passengersReducer, PassengersState } from './passengers/reducers';
import { priceBreakdownReducer, PriceBreakdownState } from './priceBreakdown/reducers';
import { orderReducer } from './order/reducers';
import { orderPriceReducer } from './orderPrice/reducers';
import { SelectedServicesState, selectedServicesReducer } from './selectedServices/reducers';
import { servicesIsSavingReducer } from './servicesIsSaving/reducers';
import { loadingServicesParamsReducer, LoadingServicesParamsState } from './loadingServicesParams/reducers';
import { seatMapReducer } from '../../SeatMap/store/reducers';
import { SeatMapState } from '../../SeatMap/store/types';
import { everyPortServicesReducer, EveryPortServicesState } from './everyPortServices/reducers';
import { everyTravelReducer, EveryTravelState } from './everyTravel/reducers';
import { AnyStateWithExchange, exchangeReducer } from '@entities/exchange';
import { ErrorState, errorReducer } from '@entities/error';
import { SubsidiesState, default as subsidiesReducer } from './subsidies/reducers';
import errorMessageReducer from './errorMessage/reducers';
import { ErrorMessageState } from './errorMessage/types';
import { orderReducer as newOrderReducer, OrderState as NewOrderState } from '@entities/order';
import { refundReducer, RefundState } from '@entities/refund';
import { refundServicesReducer, RefundServicesState } from '@entities/refund-services';

export type CheckoutState = AnyStateWithExchange<{
	order: CheckoutOrderFragment;
	newOrder: NewOrderState;
	passengers: PassengersState[];
	priceBreakdown: PriceBreakdownState;
	orderPrice: OrderPrice;
	selectedServices: SelectedServicesState;
	seatMap: SeatMapState;
	servicesIsSaving: boolean;
	loadingServiceParams: LoadingServicesParamsState;
	everyPort: EveryPortServicesState;
	everyTravel: EveryTravelState;
	refund: RefundState;
	refundServices: RefundServicesState;
	error?: ErrorState;
	subsidies: SubsidiesState;
	errorMessage: ErrorMessageState;
}>;

export const rootReducer = combineReducers<CheckoutState>({
	order: orderReducer,
	newOrder: newOrderReducer,
	passengers: passengersReducer,
	priceBreakdown: priceBreakdownReducer,
	orderPrice: orderPriceReducer,
	selectedServices: selectedServicesReducer,
	servicesIsSaving: servicesIsSavingReducer,
	seatMap: seatMapReducer,
	loadingServiceParams: loadingServicesParamsReducer,
	everyPort: everyPortServicesReducer,
	everyTravel: everyTravelReducer,
	error: errorReducer,
	subsidies: subsidiesReducer,
	errorMessage: errorMessageReducer,
	exchange: exchangeReducer,
	refund: refundReducer,
	refundServices: refundServicesReducer
});
